/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AwardDto model module.
 * @module model/AwardDto
 * @version v1.0.0
 */
class AwardDto {
    /**
     * Constructs a new <code>AwardDto</code>.
     * @alias module:model/AwardDto
     */
    constructor() { 
        
        AwardDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AwardDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AwardDto} obj Optional instance to populate.
     * @return {module:model/AwardDto} The populated <code>AwardDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AwardDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
            if (data.hasOwnProperty('yearOf')) {
                obj['yearOf'] = ApiClient.convertToType(data['yearOf'], 'String');
            }
        }
        return obj;
    }


}

/**
 * id
 * @member {String} id
 */
AwardDto.prototype['id'] = undefined;

/**
 * name
 * @member {String} name
 */
AwardDto.prototype['name'] = undefined;

/**
 * seq
 * @member {Number} seq
 */
AwardDto.prototype['seq'] = undefined;

/**
 * yearOf
 * @member {String} yearOf
 */
AwardDto.prototype['yearOf'] = undefined;






export default AwardDto;

